
import {defineComponent} from "vue";
import CbsOverview from "@/components/layouts/content-blocks/overview/CbsOverview.vue";
import {ContentOverviewRestDto} from "@/api/pharma-cms-content-block/models";
import {NormalContentBlockRestService} from "@/services/rest/cms-content-block/NormalContentBlockRestService";
import {FormMixin} from "@/components/base/FormMixin";

export default defineComponent({
  name: "StandardHomepageContentBlocksOverview",
  mixins: [FormMixin],
  components: {CbsOverview},
  data: () => ({
    contentBlocks: [] as ContentOverviewRestDto[],
    cbType: 'SMA_HOMEPAGE_TEXT_WITH_IMAGE',
  }),
  mounted() {
    this.reloadContent();
  },
  computed: {
    hasContentBlocks(): Boolean {
      return this.contentBlocks.length > 0;
    },
  },
  methods: {
    async doReload() {
      this.contentBlocks = await NormalContentBlockRestService.getInstance().findContentBlockOverview(this.cbType);
    },
    async doDeleteItemWithKey(itemKey: string): Promise<void> {
      await NormalContentBlockRestService.getInstance().deleteContentBlock(this.cbType, itemKey);
    },
  }
});
